import { Icon, Stack, Text, Title, Tooltip } from "@bookingcom/bui-react";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline";

type ChartHeaderProps = {
  titleText: string;
  titleTooltipText?: string;
  subtitleText?: string;
  subtitleValue?: string;
  subtitleExtra?: string;
};

export const ChartHeader = ({
  titleText,
  titleTooltipText,
  subtitleText,
  subtitleValue,
  subtitleExtra,
}: ChartHeaderProps) => {
  return (
    <div className="apexcharts-header">
      <Stack direction="column" gap={1}>
        <Stack direction="row" alignItems="baseline" gap={2}>
          <Title title={titleText} variant="headline_3" />
          {titleTooltipText && (
            <Tooltip text={titleTooltipText} position="top-start">
              {(attributes) => (
                <Icon svg={QuestionMarkCircleIcon} size="small" color="action" attributes={attributes} />
              )}
            </Tooltip>
          )}
        </Stack>
        {subtitleText && subtitleValue && (
          <Stack direction="row" gap={1}>
            <Text variant="body_2">{subtitleText}</Text>
            <Text variant="strong_2" color="action">
              {subtitleValue}
            </Text>
            {subtitleExtra && (
              <Text variant="body_2" color="action">
                {subtitleExtra}
              </Text>
            )}
          </Stack>
        )}
      </Stack>
    </div>
  );
};
